// YunEmVibrato.js

import { memo } from 'react'
import './YunEmVibrato.css';

import YunIcon from '../YunIcon/YunIcon';

import Slider from '@material-ui/core/Slider';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputBox from '../InputBox/InputBox';

import { formatShowValue } from '../YunEmFineTune/tool';

const YunEmVibrato = memo(function YunEmVibrato({ emVibratoVal, handleEmVibrato, vibratoPreset, emVibrato }){

    const labelValue = formatShowValue(emVibratoVal, vibratoPreset)

    if (!emVibrato) {
        return null
    }
    const handleSelectPresetValue = (val) => {
        handleEmVibrato(val);
    }

    const MenuItemEle = []
    vibratoPreset.forEach((ele, index) => {
        MenuItemEle.push(<MenuItem className="SelectItem" value={ele.value} key={'virato-item-' + index}>{ele.name}</MenuItem>)
    })

    return (
        <div className="YunCommonLayoutWrapper">
            <div className="YunEmVibrato YunCommonLayout">
                <div className="Label CursorDefault">
                    颤音：
                </div>
                <Slider
                    value={emVibratoVal}
                    onChange={(e, val) => handleEmVibrato(val)}
                    step={0.1}
                    min={-12}
                    max={12} />
                <div className="RateSelect">
                    <div className="RateSelectLabel HoverColor MainColor">{labelValue}</div>
                    <YunIcon iconClass="MainColor HoverColor" icon="expand"></YunIcon>
                    <Select value="" onChange={(e, child) => handleSelectPresetValue(child.props.value)}>
                        {MenuItemEle}
                        <InputBox val={emVibratoVal} min={-12} max={12} step={0.1} onChange={handleEmVibrato} >
                        </InputBox>
                    </Select>
                </div>
            </div>
        </div>
    )
})

export default YunEmVibrato;
